module.exports = __webpack_public_path__ + "img/game--apex-legends.e27574a0.png";